<div class="widget__wrap">
        <div class="widget" id="articles-widget">
            <h2 class="widget__header">
                <span class="widget__header__title">
                    <i class="widget__header__icon ico-angle-down"></i> Články blogu</span>
                <span class="widget__header__tools">
                    <swb-filter-list (modelChange)="filter($event)"></swb-filter-list>
                    <a [routerLink]="['articles/add']" class="cta cta--small cta--green">
                        <span class="cta__light">Přidat</span> článek
                        <i class="ico-plus"></i>
                    </a>
                </span>
            </h2>
            <div class="widget__content">
                <swb-article-list [query]="query"></swb-article-list>
            </div>
        </div>
    </div>